import { useTranslation } from '@mint-lib/i18n';
import { Checkbox, Chip, Label } from '@mint-lib/tw-components';

import type { Email } from '../../../types/index.js';
import EmailForm from './EmailForm.jsx';

type Props = {
  emails: Email[];
  onAdd?: (value: string) => void;
  onError?: (message: string) => void;
  isChecked: boolean;
  toggleCheck: () => void;
  onDelete: (email: Email) => void;
  isCheckboxError: boolean;
};

const EmailFormWithChips = ({
  emails,
  onAdd = () => null,
  onError = () => null,
  isChecked,
  toggleCheck,
  onDelete,
  isCheckboxError,
}: Props) => {
  const { t } = useTranslation('@myn/integrations_v2');

  return (
    <div className="mt-4">
      <EmailForm onAdd={onAdd} onError={onError} emails={emails} />
      <div className="flex flex-row items-center justify-start gap-2">
        {emails.map((value) => (
          <Chip
            deletable
            color="secondary"
            key={value.id}
            onDelete={() => onDelete(value)}
          >
            {value.email}
          </Chip>
        ))}
      </div>
      <div className="mt-4 flex items-center gap-2">
        <Label
          className={
            isCheckboxError
              ? 'cursor-pointer text-error-main'
              : 'cursor-pointer'
          }
          htmlFor="permission"
          variant="bodyLong01"
        >
          <Checkbox id="permission" checked={isChecked} onClick={toggleCheck} />
          {`${t('These people gave me permission to e-mail them')} *`}
        </Label>
      </div>
    </div>
  );
};

export default EmailFormWithChips;
